import { render, staticRenderFns } from "./CoAudio.vue?vue&type=template&id=627db620&scoped=true&"
import script from "./CoAudio.vue?vue&type=script&lang=js&"
export * from "./CoAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627db620",
  null
  
)

export default component.exports